/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useContext } from "react";
import { ImageList } from "@mui/material";
import GalleryContext from "components/webpage-selector/gallery/context";
import SelectGalleryItem from "components/webpage-selector/gallery/select-gallery-item";

export default function ListGallery () {

    const ctx = useContext(GalleryContext);
    const {
        webpages,
        selectedWebpage,
    } = ctx;

    return (
        <>
            <ImageList
                cols={6}
                rowHeight={100}
                className="image-selector-image-gallery-frame"
            >
                {webpages ?
                    webpages.map((webpage, index) => {
                        const isSelected = webpage?.guid === selectedWebpage?.guid;
                        return (
                            <SelectGalleryItem
                                webpage={webpage}
                                isSelected={isSelected}
                                key={index}
                            />
                        );
                    })
                    : <></>
                }
            </ImageList>
        </>
    );
}
